import { render, staticRenderFns } from "./ChoicePicker.vue?vue&type=template&id=23eb0b7f"
import script from "./ChoicePicker.vue?vue&type=script&lang=js"
export * from "./ChoicePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports